import {getTargetContainers, getTargetContainerSyncHandler} from '../utility/target-sync';

const COMPONENT_NAME = "accordion";
const CLASS_SELECTOR = ".Accordion";
const CHILD_SELECTOR = ".AccordionItem,[data-accordion-item]";
const CHILD_TOGGLE_SELECTOR = ".AccordionItem-toggle";
const CHILD_CONTENT_SELECTOR = ".AccordionItem-content";
const CHILD_INNER_SELECTOR = ".AccordionItem-inner";
const TARGET_CONTENT_SELECTOR = '[data-accordion-target]';

const ACTIVE_CLASS = "is-active";

const instances = [];

function initialize(element, PageComponents) {
    const targetSelector = element.getAttribute("data-target");
    const childElements = element.querySelectorAll(CHILD_SELECTOR);
    const targetContentSelector = element.getAttribute("data-target-child-selector") || TARGET_CONTENT_SELECTOR;
    const contentElementList = getTargetContainers(targetSelector, targetContentSelector, childElements);

    let activeItemIndex = 0;

    function syncChildren(index) {
        childElements.forEach((child, i) => {
            const isActive = i === index;
            const content = child.querySelector(CHILD_CONTENT_SELECTOR);
            if (isActive) {
                const inner = child.querySelector(CHILD_INNER_SELECTOR);
                content.style.height = inner.getBoundingClientRect().height + 'px';
            } else {
                content.style.height = "0";
            }
            child.classList.toggle(ACTIVE_CLASS, i === index);
        });
    }
    const syncTargets = getTargetContainerSyncHandler(contentElementList, ACTIVE_CLASS);

    function sync(index) {
        syncChildren(index);
        syncTargets(index);
        activeItemIndex = index;
    }

    childElements.forEach((child, index) => {
        if (child.classList.contains(ACTIVE_CLASS)) {
            activeItemIndex = index;
        }

        const toggle = child.querySelector(CHILD_TOGGLE_SELECTOR);

        // Add desktop tab click handler
        (toggle || child).addEventListener('click', (e) => {
            e.stopPropagation();
            sync(index);
        });
    });
    sync(activeItemIndex);

    instances.push({
        children: childElements,
        targets: contentElementList,
        sync
    });
}

export default {
    name: COMPONENT_NAME,
    instances,
    initialize
};
